import OverdueClientsRequests from '../../server/overdueClients';
import { addLoading, removeLoading } from './loading';

export const setOverdueClients = data => ({
  type: 'GET_OVERDUE_CLIENTS',
  data,
});

export const getOverdueClients = ({
  page, limit, orderBy, search,
}) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const overdueClients = await OverdueClientsRequests.getOverdueClients({
      page,
      limit,
      orderBy,
      search,
    });
    dispatch(setOverdueClients(overdueClients));
  } finally {
    dispatch(removeLoading());
  }
};
